import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Injectable } from '@angular/core';

import { FilterOptions } from '@shared/interfaces/filterOptions.interface';
import { ApiPaymentService } from '../api/api-payment.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  entity!: FormGroup
  formMethod = 'CREATE'
  accounts: { label: string; value: string; }[] = [
    { label: "Selecciona una opción", value: "" }
  ]
  paymentMethods: { label: string; value: string; }[] = [
    { label: "Efectivo", value: "Efectivo" },
    { label: "Transferencia", value: "Transferencia" },
    { label: "Deposito", value: "Deposito" },
    { label: "Cheque", value: "Cheque" },
    { label: "Spei", value: "Spei" }
  ];
  statuses: { label: string; value: string; }[] = [
    { label: "PENDING", value: "PENDING" },
    { label: "APPLIED", value: "APPLIED" },
    { label: "CANCELLED", value: "CANCELLED" }
  ];
  clients: { label: string; value: string; }[] = []

  constructor(
    private fb: FormBuilder,
    private apiPaymentService: ApiPaymentService
  ) {
    this.fetchAccounts({ page: 1, limit: 100, filters: {} })
    this.getClients()
  }

  newEntity() {
    switch (this.formMethod) {
      case 'CREATE':
        this.entity = this.fb.group({
          client: ['', [Validators.required]],
          amount: [0, [Validators.required, Validators.min(1)]],
          trackingKey: ['', [Validators.required]],
          account: ['', [Validators.required]],
          paymentMethod: ['', [Validators.required]],
          date: ['', [Validators.required]],
        })
        break;
    }
  }

  /**
   * Guarda el pago conservando el 409 de duplicado. `getRawValue()` y no `.value` porque el cliente
   * puede venir deshabilitado (alta desde la pestaña Exigibilidad, donde ya está decidido) y `.value`
   * omite los controles deshabilitados. El actor ya no viaja en el cuerpo: sale del token (F22).
   */
  save(extra: { confirmDuplicate?: boolean, duplicateReason?: string } = {}) {
    return this.apiPaymentService.createWithDuplicateCheck({ ...this.entity.getRawValue(), ...extra })
  }

  getAccountName(id: string) {
    return this.accounts.find(c => c.value === id)?.label
  }

  fetchAccounts(filterOptions: FilterOptions) {
    this.apiPaymentService.fetchAccounts(filterOptions).subscribe(
      accounts => {
        this.accounts = [...accounts]
      },
      error => {
        console.error('Error al obtener las cuentas:', error);
      }
    )
  }

  getClients() {
    this.apiPaymentService.getClients().subscribe(
      clients => {
        this.clients = clients.data.data.map((client: any) => ({
          label: client.name,
          value: client._id
        }))
      },
      error => {
        console.error('Error al obtener los clientes:', error);
      }
    )
  }
}
